import type {CSSProperties} from 'react';
import {font, leading} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeNotesAreaVariant = 'wedge-notes-area';

export const isWedgeNotesAreaVariant = (variant: unknown): variant is WedgeNotesAreaVariant => variant === 'wedge-notes-area';

const MIN_HEIGHT = 120;

/* Released transcript textarea of the Notes app dictation sheet (`.rvn-transcript`): one bare native textarea at full width on the alternate
   surface, 120px tall at least, with vertical resize, 12px by 14px padding, 16px type at line height 1.55. The `rvn-transcript` class keeps the rest,
   and the look leaves each of these out on purpose, because the class or the shipped sheet owns it:
   - the whole border: `.rvn-transcript:focus` sets the border color, so the shorthand stays on the class;
   - the radius, the outline and the box shadow: `:focus` sets the 4px accent ring and `.wedge-scope textarea:focus-visible` draws the shipped ring;
   - the height cap: the source writes the pair `36vh` then `36dvh` for old engines, and React writes one value;
   - the font shorthand: the family comes from the shipped sheet, and the look sets only the size and the line height.
   The caller owns the value, the handlers, the ref (it focuses the field when the sheet has no mic) and the row count; the legacy textarea has none,
   and the caller passes none (the default is 2). Each color reads the exact legacy role, so the shipped ink rules keep matching. */
export function wedgeNotesAreaStyle(): CSSProperties {
  const r = wedgeExactRole;
  return {
    width: '100%', boxSizing: 'border-box', minHeight: MIN_HEIGHT, resize: 'vertical', background: r('surfaceAlt'), color: r('label'),
    padding: '12px 14px', fontSize: font.headline, lineHeight: leading.relaxed,
  };
}
